import React, { ChangeEvent, useContext } from 'react';
import Button from '@mui/material/Button';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import ScorecardManagementTableRowViewModel from './Viewmodels/ScorecardManagementTableRowViewModel';
import EditIcon from '@mui/icons-material/Edit';
import Switch from '@mui/material/Switch';
import { APIContext } from '../Contexts/APIContext';

type Props = {
    row: ScorecardManagementTableRowViewModel;
    getData: () => void;
    edit: (id: number) => void;
}

export default function ScorecardManagementTableRow({ row, getData, edit }: Props) {
    const { get } = useContext(APIContext);
    const toggleActive = (e: ChangeEvent<HTMLInputElement>) => {
        get('ScorecardManagement', `ToggleActiveScorecardTemplate?templateId=${row.id}`, () => {
            getData();
        });
    }

    return (
        <TableRow>
            <TableCell>{row.name}</TableCell>
            <TableCell>{row.client}</TableCell>
            <TableCell>{row.channel ? row.channel : "All"}</TableCell>
            <TableCell>{row.scorecardType}</TableCell>
            <TableCell>{row.customerLevel ? "Yes" : "No"}</TableCell>
            <TableCell align="right">{row.passThreshold}</TableCell>
            <TableCell align="right">{row.resQPassThreshold}</TableCell>
            <TableCell>
                <Switch checked={row.active} onChange={toggleActive} />
            </TableCell>
            <TableCell align="right">
                <Button
                    variant="contained"
                    size="small"
                    onClick={() => edit(row.id)}
                ><EditIcon /></Button>
            </TableCell>
        </TableRow>
    );
}